import React from 'react'
import { translate } from 'react-i18next'
import { func, object } from 'prop-types'
import { withRouter } from 'react-router'
import { SubHero } from '../../components/header/SubHero'
import { InvoiceList } from '../../components/customer/InvoiceList'
import { Wallet } from '../../components/customer/wallet/Wallet'
import { AccountDetails } from '../../components/customer/AccountDetails'
import { Rewards } from '../../components/customer/rewards/Rewards'
import { NewInquiryBanner } from '../../components/ui/NewInquiryBanner'
import './MyAccountPage.css'

export const MyAccountPageComponent = ({ t, location }) => {
  const breadcrumb = [{ name: t('common:account:my'), path: '' }]
  return (
    <div>
      <SubHero breadcrumb={breadcrumb} />
      <div className='layout__container account'>
        <NewInquiryBanner />
        <h2>{t('common:account:personnal')}</h2>
        <AccountDetails />
        <h2>{t('common:account:title_credit')}</h2>
        {
          location.search && location.search.includes('error')
            ? <p className='form__errormessage'>{t('common:payment:error')}</p>
            : ''
        }
        <Wallet />
        <h2>{t('common:account:title_rewards')}</h2>
        <Rewards />
        <h2>{t('common:account:title_invoice')}</h2>
        <InvoiceList />
      </div>
    </div>)
}

MyAccountPageComponent.propTypes = {
  t: func,
  location: object
}
export const MyAccountPage = translate()(withRouter(MyAccountPageComponent))



// WEBPACK FOOTER //
// ./src/pages/compte/MyAccountPage.js